import React from "react";
import { Accordion, Card, Col } from "react-bootstrap";
import { IoMdCheckmark } from "react-icons/io";

import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { Row } from "react-bootstrap";
import { VFL_STATUS } from "../CONSTANTS";
import { BsFillInfoCircleFill } from "react-icons/bs";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { useEmployeeDropdown } from "app/_helpers/hooks";
import { isArray } from "lodash";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";

const VFLTimeline = ({ form, capaTimeLine }) => {
  const [, employeesOption] = useEmployeeDropdown();

  const vflScheduledFlag = form?.schedularData ? true : false;
  const vflAssignedFlag = form?.vflAssignedDate ? true : false;
  const vflExecutedFlag = form.vflExecutionDateTime ? true : false;
  const vflCompletedFlag = form.vflStatus === VFL_STATUS.completed ? true : false;
  const vflCapaFlag = form?.capaCompletionDate ? true : false;

  return (
    <div className="card p-3  pb-3 mt-0 mb-2">
      <Row>
        <Col lg={capaTimeLine ? 4 : 8}>
          <Accordion defaultActiveKey="1" className="timeline">
            <div
              className={`timelineSection ${
                vflScheduledFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflScheduledFlag ? "1" : "0"}>
                <div
                  className={`number ${
                    vflScheduledFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflScheduledFlag ? <IoMdCheckmark /> : 1}
                </div>
                <h4>VFL Scheduled</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="1">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Scheduler By</h5>
                        <h5>{"Safety Officer"}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name of Scheduler</h5>
                        <h5>{userDropdownLabel(form?.schedularData)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Scheduled Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(form?.createdAt)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vflAssignedFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflAssignedFlag ? "2" : "0"}>
                <div
                  className={`number ${
                    vflAssignedFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflAssignedFlag ? <IoMdCheckmark /> : 2}
                </div>
                <h4>VFL Approved</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="2">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">VFL Approved By</h5>
                        <h5>{"Mines Manager"}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approver Name</h5>
                        <h5>{userDropdownLabel(form?.vflAssignerData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vflAssignedFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflAssignedFlag ? "3" : "0"}>
                <div
                  className={`number ${
                    vflAssignedFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflAssignedFlag ? <IoMdCheckmark /> : 3}
                </div>
                <h4>VFL Assigned</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="3">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">VFL Team Leader</h5>
                        <h5>{userDropdownLabel(form?.vflOfficerData)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey whiteTooltip">
                          Team Members&nbsp;
                          <CustomPopover
                            placement={"right"}
                            tooltip={
                              <>
                                <h3 className="tooltipHeader popover-header">
                                  Team Members
                                </h3>
                                <table className="table table-bordered mb-0">
                                  <thead>
                                    {/* <tr>
                                      <th rowSpan={2}>#</th>
                                      <th colSpan={3} className="text-center">
                                        Team Members
                                      </th>
                                    </tr> */}
                                    <tr>
                                      <th>#</th>
                                      <th>Name</th>
                                      <th>Email Id</th>
                                      <th>Employee Id</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {form?.employeeIds?.split(",")?.map((id) => {
                                      const found = employeesOption.find(
                                        (site) => site.id === +id
                                      );
                                      return (
                                        <tr>
                                          <td>{id}</td>
                                          <td>{found?.label?.split(" / ")?.[0]}</td>
                                          <td>{found?.label?.split(" / ")?.[1]}</td>
                                          <td>{found?.label?.split(" / ")?.[2]}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </>
                            }
                          >
                            <BsFillInfoCircleFill />
                          </CustomPopover>
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Assigned Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(form?.vflAssignedDate)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vflExecutedFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflExecutedFlag ? "4" : "0"}>
                <div
                  className={`number ${
                    vflExecutedFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflExecutedFlag ? <IoMdCheckmark /> : 4}
                </div>
                <h4>VFL Executed</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="4">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">VFL Team Leader</h5>
                        <h5>{userDropdownLabel(form?.vflOfficerData)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Execution Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(form?.vflExecutionDateTime)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vflCapaFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflCapaFlag ? "5" : "0"}>
                <div
                  className={`number ${
                    vflCapaFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflCapaFlag ? <IoMdCheckmark /> : 5}
                </div>
                <h4>VFL CAPA</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="5">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">
                          CAPA Completion Date&nbsp;
                          <CustomPopover
                            placement={"right"}
                            tooltip={
                              <>
                                <table className="table table-bordered tooltipTable">
                                  <thead>
                                    <tr>
                                      <th>CAPA ID</th>
                                      <th>Owner</th>
                                      <th>Completion Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {isArray(form?.vflObservations) &&
                                      form?.vflObservations
                                        .filter(
                                          (d) =>
                                            !["safeCondition", "safeAct"].includes(d.type)
                                        )
                                        .map((observation) => {
                                          return observation?.allCapa.map(
                                            (data, index) => {
                                              return (
                                                <tr>
                                                  <td>{data.capaId}</td>
                                                  <td>
                                                    {data.owner?.firstName}{" "}
                                                    {data.owner?.lastName}
                                                  </td>
                                                  <td>
                                                    {DDMMYYYYHHMMAFormat(
                                                      data.completionDate
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          );
                                        })}
                                  </tbody>
                                </table>
                              </>
                            }
                          >
                            <BsFillInfoCircleFill />
                          </CustomPopover>
                        </h5>
                        <h5>{DDMMYYYYHHMMAFormat(form?.capaCompletionDate)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vflCompletedFlag ? "completedtimelineSection" : "pendingtimelineSection"
              } lastTimeLine`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vflCompletedFlag ? "6" : "0"}>
                <div
                  className={`number ${
                    vflCompletedFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflCompletedFlag ? <IoMdCheckmark /> : 6}
                </div>
                <h4>VFL Completed</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="6">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approved By</h5>
                        <h5>{"Mines Manager"}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approver Name </h5>
                        <h5>{userDropdownLabel(form?.vflClosedByData)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approval Date</h5>
                        <h5>{DDMMYYYYHHMMAFormat(form?.vflClosedDate)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </Col>
        {capaTimeLine && (
          <Col lg={4}>
            {isArray(form?.vflObservations) &&
              form?.vflObservations.filter(
                (d) => !["safeCondition", "safeAct"].includes(d.type)
              )?.length !== 0 && (
                <table className="table table-bordered tooltipTable">
                  <thead>
                    <tr>
                      <th>CAPA ID</th>
                      <th>Owner</th>
                      <th>Completion Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isArray(form?.vflObservations) &&
                      form?.vflObservations
                        .filter((d) => !["safeCondition", "safeAct"].includes(d.type))
                        .map((observation) => {
                          return observation?.allCapa.map((data, index) => {
                            return (
                              <tr>
                                <td>{data.capaId}</td>
                                <td>
                                  {data.owner?.firstName} {data.owner?.lastName}
                                </td>
                                <td>{DDMMYYYYHHMMAFormat(data.completionDate)}</td>
                              </tr>
                            );
                          });
                        })}
                  </tbody>
                </table>
              )}
          </Col>
        )}
        <Col lg={4}>
          <div className="timelineText mmInputScreen mt-3">
            <ul className="list-inline d-flex">
              <li className="secInfo">
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">VFL Date</h5>
                  <h5 className="mb-1">{DDMMYYYYFormat(form?.vflScheduledDateTime)}</h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">VFL Executive (Team Leader)</h5>
                  <h5 className="mb-1">{`${userDropdownLabel(form?.vflOfficerData)}`}</h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">Mine</h5>
                  <h5 className="mb-1">{form?.siteData?.name}</h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">Regional Office</h5>
                  <h5 className="mb-1">{form?.siteData?.parentSite?.name}</h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">Area of Operation</h5>
                  <h5 className="mb-1">{form?.ehs_area_of_operations?.name}</h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">Sub Area of Operation</h5>
                  <h5 className="mb-1">
                    {form?.subAreaId === 0
                      ? "Other"
                      : (form?.ehs_area_of_operations?.subAreaOfOperation || []).find(
                          (d) => d.id === form?.subAreaId
                        )?.name}
                  </h5>
                </div>
                <div className="timelineRow py-1">
                  <h5 className="txtgrey mb-1">Scheduled by</h5>
                  <h5 className="mb-1">{`${userDropdownLabel(form?.schedularData)}`}</h5>
                </div>
                {vflAssignedFlag && (
                  <>
                    <div className="timelineRow py-1">
                      <h5 className="txtgrey mb-1">Approved By</h5>
                      {userDropdownLabel(form?.vflAssignerData)}
                    </div>
                    <div className="timelineRow py-1">
                      <h5 className="txtgrey mb-1">Approval Date</h5>
                      {DDMMYYYYHHMMAFormat(form?.vflAssignedDate)}
                    </div>
                  </>
                )}
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VFLTimeline;
